import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import CampaignDropdown from '../CampaignDropdown'
import AssigneeDropdown from '../AssigneeDropdown'
import { useCreateTaskDistributionMutation } from '../../redux/apis/taskManagement/tMDistriputionApiSlice'

const AssignTask = ({ open, setOpen }) => {
  const [
    createTaskDistribution,
    { isLoading: isCreating, isSuccess: successCreate, error: errorCreate }
  ] = useCreateTaskDistributionMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      user: '',
      campaigns: [],
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      user: Yup.number().required('Please select an Assignee'),
      campaigns: Yup.array()
        .of(Yup.number())
        .min(1, 'Please select at least one Campaign')
        .required('Please select at least one Campaign')
    }),

    onSubmit: async values => {
      try {
        const { user, campaigns, last_updated_by } = values
        await createTaskDistribution({ user, campaigns, last_updated_by }).unwrap()
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorCreate?.data) {
      const collect = e =>
        Array.isArray(e)
          ? e.flatMap(collect)
          : e && typeof e === 'object'
            ? Object.values(e).flatMap(collect)
            : [e]
      const messages = collect(errorCreate.data.errors).filter(Boolean)
      if (messages.length) {
        messages.forEach(message => toast.error(message))
      } else if (errorCreate.data.message) {
        toast.error(errorCreate.data.message)
      }
    }
  }, [errorCreate])

  useEffect(() => {
    if (successCreate) {
      toast.success('Task(s) assigned successfully!')
      setOpen(false)
      validation.resetForm()
    }
  }, [successCreate])

  return (
    <Modal
      className='customModal'
      open={open}
      title='Assign Tasks'
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isCreating} />

      <AssigneeDropdown
        onChange={e => {
          validation.setFieldValue('user', e)
        }}
        value={validation.values.user}
        onBlur={validation.handleBlur}
      />
      {validation.touched.user && validation.errors.user ? (
        <p className='text-danger'>{validation.errors.user}</p>
      ) : null}

      <CampaignDropdown
        mode='multiple'
        onChange={e => {
          validation.setFieldValue('campaigns', e)
        }}
        value={validation.values.campaigns}
        onBlur={validation.handleBlur}
      />
      {validation.touched.campaigns && validation.errors.campaigns ? (
        <p className='text-danger'>{validation.errors.campaigns}</p>
      ) : null}
    </Modal>
  )
}

export default AssignTask
